var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"micro-headerwidgets-projects",attrs:{"data-plugin-name":_vm.VUE_APP_NAME,"id":_vm.VUE_APP_NAME}},[_c('Products',{key:_vm.service.refreshKey,attrs:{"service":_vm.service}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }